export enum DesignType {
  UNKNOWN = 'Unknown',
  EMPTY = 'Empty',
  GRAPHIC = 'Graphic',
  SMARTLINE = 'SmartLine',
  WEBWEAVE = 'WebWeave',
  QRCODE = 'QrCode',
  STRESS = 'Stress'
}
